interface LogoProps {
  compact?: boolean;
  inverse?: boolean;
}

export function Logo({ compact = false, inverse = false }: LogoProps) {
  return (
    <a className={`logo ${inverse ? "logo--inverse" : ""}`} href="/" aria-label="PRT Technology home">
      <img className="logo__mark" src="/prt-technology-logo.webp" width="64" height="64" alt="" aria-hidden="true" />
      {!compact && <span className="logo__text">PRT Technology</span>}
    </a>
  );
}
